// src/services/invoicesService.js
import {
  doc,
  updateDoc,
  collection,
  addDoc,
  deleteDoc,
  onSnapshot,
  query,
  orderBy,
  serverTimestamp,
} from "firebase/firestore";
import {
  getStorage,
  ref,
  uploadBytesResumable,
  getDownloadURL,
  deleteObject,
} from "firebase/storage";
import { db } from "../firebase";

/* ==== оплата ==== */
export async function setPaymentMethod(uid, method = "card") {
  await updateDoc(doc(db, "users", uid), { paymentMethod: method });
}

/* ==== підписка на рахунки користувача ==== */
export function subscribeUserInvoices(uid, cb) {
  const q = query(
    collection(db, "users", uid, "invoices"),
    orderBy("orderDate", "desc")
  );
  return onSnapshot(q, (snap) => {
    cb(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
  });
}

/* ==== завантажити новий рахунок ==== */
export async function uploadInvoicePdf(
  uid,
  file,
  orderDate /* Date | string */
) {
  if (!file) throw new Error("File is required");
  const storage = getStorage();
  const safeName = `${Date.now()}-${file.name.replace(/\s+/g, "_")}`;
  const path = `invoices/${uid}/${safeName}`;
  const storageRef = ref(storage, path);

  await new Promise((resolve, reject) => {
    const task = uploadBytesResumable(storageRef, file, {
      contentType: "application/pdf",
    });
    task.on("state_changed", null, reject, resolve);
  });

  const url = await getDownloadURL(storageRef);
  const orderTs = orderDate
    ? orderDate instanceof Date
      ? orderDate
      : new Date(orderDate)
    : new Date();

  await addDoc(collection(db, "users", uid, "invoices"), {
    fileName: file.name,
    url,
    gsPath: path,
    orderDate: orderTs,
    createdAt: serverTimestamp(),
  });
}

/* ==== видалити рахунок ==== */
export async function removeInvoice(uid, invoice) {
  // 1) видалити файл
  if (invoice?.gsPath) {
    try {
      await deleteObject(ref(getStorage(), invoice.gsPath));
    } catch (e) {
      console.warn("deleteObject error", e);
    }
  }
  // 2) видалити документ
  await deleteDoc(doc(db, "users", uid, "invoices", invoice.id));
}
